<ui-dialog
    [form]="compensationReportFilterForm.form"
    [open]="isFilterModalOpen"
    size="small"
    (closing)="isFilterModalOpen = false"
    primaryButtonLabel="save"
    (primaryButtonPressed)="onFilter(compensationReportFilterForm.filters)"
    secondaryButtonLabel="cancel"
    header="filter"
>
    <app-compensation-report-filter-form
        #compensationReportFilterForm
        (filterApplied)="onFilter($event)"
    ></app-compensation-report-filter-form>
</ui-dialog>

<div class="page-container" [class.loading]="isLoading">
    <app-header [back]="true" title="reporting.reports.compensationReport.title">
        <div class="buttons">
            <ui-button type="outline" (click)="isFilterModalOpen = true">{{ 'filter' | translate }}</ui-button>
            <ui-button type="primary" [matMenu]="exportMenu">
                {{ 'export' | translate }} <mat-icon svgIcon="chevronDown"></mat-icon>
            </ui-button>
            <mat-menu #exportMenu="matMenu">
                <button mat-menu-item (click)="onExport('csv')">{{ 'export-as-csv' | translate }}</button>
                <button mat-menu-item (click)="onExport('xlsx')">{{ 'export-as-xlsx' | translate }}</button>
            </mat-menu>
        </div>
    </app-header>
    <h4 class="margin-top-0 margin-bottom-0" style="text-align: left">
        {{ 'reporting.reports.compensationReport.longDescription' | translate }}
    </h4>
    <h4 class="margin-top-0">
        {{
            'reporting.reports.dateRange'
                | translate
                    : { startDate: (startDate | appDate: 'mediumDate'), endDate: (endDate | appDate: 'mediumDate') }
        }}
    </h4>
    <div *ngIf="report && report.data.sheets && report.data.sheets.length; else emptyState" class="report-body">
        <app-report-table #reportTable [report]="report"></app-report-table>
    </div>
</div>

<ng-template #emptyState>
    <ui-card>
        <app-empty-state label="reporting.reports.noDataWithFiltersApplied"></app-empty-state>
    </ui-card>
</ng-template>
